<template>
  <div class="login">
    <header><img src="static/logo.png" /></header>
    <!-- <header><img src="static/logo_ruida.jpg" /></header> -->
    <section class="logo_main">
      <form @focusin="focusinMethod" @focusout="focusoutMethod">
        <!--账号密码登录-->
        <div class="big-wrapper" v-show="false">
          <div class="man">
            <div class="icon-left">
              <i class="iconfont" :class="{ 'iconfont-color': ipNum != '' }">&#xe60f;</i>
            </div>
            <div class="icon-right">
              <input class="form-control ip-input" name="username" v-model="ipNum" :disabled="isIpNumDisabled" type="text" maxlength="15" minlength="1" placeholder="请输入接入授权码" />
            </div>
          </div>
        </div>

        <div class="big-wrapper">
          <div class="man">
            <div class="icon-left">
              <i class="icon iconfont" :class="{ 'iconfont-color': accountNum != '' }">&#xe66c;</i>
            </div>
            <div class="icon-right">
              <input type="text" v-model="accountNum" maxlength="15" minlength="1" class="form-control" name="username" placeholder="请输入账号" />
            </div>
          </div>
        </div>

        <div class="big-wrapper">
          <div class="man">
            <div class="icon-left">
              <i class="icon iconfont" :class="{ 'iconfont-color': passwordNum != '' }">&#xe654;</i>
            </div>
            <div class="icon-right">
              <input type="password" v-model="passwordNum" maxlength="15" minlength="1" class="form-control" name="username" placeholder="请输入密码" />
            </div>
            <!-- 新增外层容器控制靠右对齐，清除文字前后空格 -->
            <span class="reme-pass-wrap" @click="handleReme">
              <i class="icon iconfont" v-if="remePass">&#xe60c;</i>
              <i class="icon iconfont" v-else>&#xe615;</i>
              <span class="dsRemePass">记住密码</span>
            </span>
          </div>
        </div>

        <div class="btn_div_d">
          <div @click="accountLogin" class="btn" :disabled="log2Disable" id="log2_dl" :class="classObject2">
            {{ this.loginText }}
            <span :class="['dot-ani', { showLoading: loginText == '登录中' }]"></span>
          </div>
        </div>

        <p class="deal_div" @click="showVersionInfo">
          <!-- 用户登录即代表同意 -->
          当前版本: {{ version2 }}
          <!-- <span @click="userProtocol">《当前版本》</span> -->
        </p>
      </form>
    </section>

    <upgrade-app v-if="upgrade.display" :upgrade="upgrade" @laterUp="handleLaterUp" />
    <!-- 密码错误提示弹窗 -->
    <!--<div class="pw_z" v-if="pw_show">-->
    <!--<div class="pw_k">-->
    <!--<div><p class="p1">登录失败!</p><p>服务器地址、账号或密码错误!</p></div>-->
    <!--<Button class='enterImfor' @click="purchaseOrder">确定</Button>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
import { MessageBox } from "mint-ui";
import model from "../../../static/js/proto/Model.js";
import front from "../../../static/js/proto/CtpFront.js";
import { version, appstoreVersion } from "@/version.js";
import * as SubUtils from "@/store/SubUtils";
import { getIp } from "@/utils/ipcoder";
import UpgradeApp from "@/views/components/UpgradeApp/UpgradeApp.vue";
import * as jsonp from "jsonp";
export default {
  name: "login",
  props: ["loginState"],
  components: {
    UpgradeApp,
  },
  data() {
    return {
      headerImgSrc: "logo_header.jpg",
      // ipNum: localStorage.ipNum, // 默认授权码
      ipNum: "fwy0za", // 固定授权码
      isIpNumDisabled: true, // 是否禁用ip授权码编辑
      accountNum: localStorage.accountNum,
      passwordNum: localStorage.passwordNum,
      loginText: "登录",
      loading: false,
      showFlag: true,
      passShow: "password",
      version2: version,
      remePass: localStorage.remePass,

      // 升级信息
      upgrade: {
        address: "",
        version: "",
        content: "",
        display: false,
      },
    };
  },
  computed: {
    //log2 登录状态控制
    log2Disable: function () {
      if (this.accountNum == "" || this.passwordNum == "" || this.loading) {
        return true;
      } else {
        return false;
      }
    },
    //log2 登录样式控制
    classObject2: function () {
      if (this.accountNum != "" && this.passwordNum != "" && !this.loading) {
        return {
          dis_btn: false,
          click_btn: true,
        };
      } else {
        return {
          dis_btn: true,
          click_btn: false,
        };
      }
    },
  },

  methods: {
    showVersionInfo() {
      MessageBox({
        title: "提示",
        message: "当前版本: " + this.version2 + "." + this.ipNum,
        confirmButtonText: "确定",
      });
    },
    prepare() {
      this.loading = false;
      this.loginText = "登录";
      this.upgrade.display = false;
    },
    logining() {
      this.loading = true;
      this.loginText = "登录中";
    },

    handleReme() {
      this.remePass = !this.remePass;
    },

    accountLogin() {
      var that = this;
      // 如果正在登录，则不能点击。
      if (this.loading) return;

      // 检查IP地址
      // const r = /^(([1-9]|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.)(([0-9]|([0-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.){2}([0-9]|([0-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))$/;
      var testIp = this.ipNum;
      testIp = this.trims(testIp, "g"); // 去除所有空格
      var ip = getIp(testIp); // 将jn62or转换为'47.242.183.99'

      // 检查授权码，账号，密码
      if (that.ipNum == "") {
        this.$toast("授权码不能为空");
        return;
      }
      if (that.accountNum == "") {
        this.$toast("账号不能为空");
        return;
      }
      if (that.passwordNum == "") {
        this.$toast("密码不能为空");
        return;
      }

      that.logining();
      front.setEvent(
        // 网络连接事件
        function () {
          that.$toast("网络已自动重连");
          that.$store.commit("autoClose", false);
          SubUtils.clearAll();
          that.$store.commit("selectLoad"); // 清空自选合约
        },
        // 网络断开事件
        function (activeClose) {
          console.error("autoClose " + !activeClose);
          if (!activeClose) {
            that.$toast("网络已断开，请检查网络连接");
            that.$store.commit("autoClose", true);
          }
        }
      );

      var option = {
        upgrade: function (user) {
          // console.log(user);
          crmAddress = user.crmAddress;
          helpAddress = user.helpAddress;
          localStorage.ipNum = testIp;
          localStorage.userName = user.userName;
          localStorage.accountNum = that.accountNum;
          localStorage.passwordNum = that.remePass ? that.passwordNum : "";
          localStorage.remePass = that.remePass;
          // 苹果Ios环境
          /////////////////////////////////////////////////////////////////////////
          if (platform.name == "ios") {
            that.upgrade.version = user.versionIos;
            that.upgrade.address = user.addressIos;
            that.upgrade.content = user.contentIos;
          } else if (platform.name == "android") {
            // Android环境
            that.upgrade.version = user.version;
            that.upgrade.address = user.address;
            that.upgrade.content = user.content;
          } else if (platform.name == "") {
            /////////////////////////////////////////////////////////////////////
            // 测试环境
            that.upgrade.version = user.version;
            that.upgrade.address = user.address;
            that.upgrade.content = user.content;
          }

          // 检查是否需要升级
          that.upgrade.display = false;
          ////// //////////////////////////////////////
          if (platform.isNeedAutoUpdate && version != that.upgrade.version) {
            that.upgrade.display = true;
          }
          ////// ////////////////////////////////
          return that.upgrade.display;
        },
        resolve: function (user) {
          localStorage.ipNum = testIp;
          localStorage.accountNum = that.accountNum;
          localStorage.passwordNum = that.remePass ? that.passwordNum : "";
          localStorage.remePass = that.remePass;
          that.$router.push({ path: "home/select" });
          SubUtils.reSub();
          SubUtils.clearAll();
        },
        reject: function (error) {
          // console.error(error);
          if (error.id == front.e_network) {
            MessageBox("登录失败", "网络错误：请检查授权码是否正确，网络是否正常。");
          } else if (error.id == front.e_account_invalid || error.id == front.e_password_invalid) {
            MessageBox("登录失败", "您输入的账号或密码错误！" + "<br />您输入的账号为：" + that.accountNum + "<br />您输入的密码为：" + that.passwordNum);
          } else {
            MessageBox("登录失败", error.message);
          }
          that.prepare();
        },
      };
      // console.log("ip", ip);
      front.login(ip, that.accountNum, that.passwordNum, option);
    },

    //点击显示隐藏密码
    show_h() {
      this.showFlag = !this.showFlag;
      this.passShow = this.passShow == "password" ? "text" : "password";
    },

    //拨打电话
    mobileCall() {
      window.location.href = "tel://400-100-1382";
    },

    //账号不存在
    altNonentity() {
      MessageBox({
        title: "账号不存在",
        message: "此手机号未被激活",
        confirmButtonText: "激活",
        cancelButtonText: "取消",
        showCancelButton: true,
      }).then(({ value, action }) => {
        this.mobileCall();
      });
    },
    //密码错误
    altPwdError() {
      MessageBox({
        title: "密码错误",
        message: "是否找回密码",
        confirmButtonText: "是",
        cancelButtonText: "否",
        showCancelButton: true,
      });
    },

    focusinMethod() {
      this.headerImgSrc = "logo_header_small.jpg";
    },
    focusoutMethod() {
      this.headerImgSrc = "header.jpeg";
    },
    userProtocol() {
      this.$router.push("userProtocol");
    },
    trims(str, is_global) {
      var result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    // 取消升级
    handleLaterUp() {
      this.upgrade.display = false;
    },
  },
  beforeCreate() {
    // document.body.style.backgroundColor="#fff";
  },
  beforeDestroy() {
    document.body.style.backgroundColor = "";
  },
  activated() {
    // this.ipNum = localStorage.ipNum; // 授权码固定，不从localStorage读取

    if (!localStorage.passwordNum) {
      this.remePass = false;
      this.passwordNum = "";
    } else {
      this.remePass = true;
      this.passwordNum = localStorage.passwordNum;
    }

    this.prepare();
    // 登录页面，不显示自动断开。
    this.$store.commit("autoClose", false);
  },
  mounted() {
    if (platform.name == "ios") {
      this.$nextTick(() => {
        // this.$jsonp('https://itunes.apple.com/cn/lookup?id=1463572015', null, (err, res) => {
        //       console.log(res);
        // });
        jsonp("https://itunes.apple.com/cn/lookup?id=1448458716", null, (err, res) => {
          var arr1 = res.results[0].version.split(".").join("");
          var arr2 = appstoreVersion.split(".").join("");
          // console.log(arr1, arr2);
          if (Number(arr1) - Number(arr2) > 0) {
            this.upgrade.display = true;
          }
        });
      });
    }
  },
};
</script>

<style scoped>
.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.36rem;
  font-style: normal;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  color: #8e8e8e;
}

.iconfont-color {
  color: #f5f9fc;
}

input {
  background: #161712;
  color: #f5f9fc;
}
.login {
  margin-top: 23%;
}

.content {
  /*display: flex;*/
  /*flex-direction: column;*/
  /*justify-content:flex-start;*/
  width: 100%;
  /*padding: 0 0.37rem;*/
  color: #999999;
  font-size: 0.32rem;
  /*height: 3.2rem;*/
}

header {
  width: 1.5rem;
  height: 3rem;
  margin: 0 auto;
  line-height: 3rem;
}

header img {
  width: 100%;
  height: 50%;
  padding-top: 0;
  padding-bottom: 0;
  vertical-align: middle;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
}

.logo_main {
  /*background: #252525;*/
  /*padding: 0 0.6rem;*/
}

form {
  flex-direction: column;
  justify-content: center;
  justify-items: center;
}

.big-wrapper {
  width: 98%;
  margin-left: 1%;
  /*background:#292929;*/
}

/* 1. 确保输入行容器（man）的高度与子元素行高匹配，强化垂直居中 */
.man {
  height: 0.85rem; /* 容器高度 */
  display: flex;
  flex-direction: row;
  align-items: center; /* 强制子元素垂直居中（核心属性） */
  justify-content: flex-start;
  margin: 0 0.5rem;
  position: relative;
}

.man::before {
  content: "  ";
  position: absolute;
  left: 0;
  top: 0.75rem;
  width: 100%;
  height: 1px;
  background-color: #fff;
  -webkit-transform: scaleY(0.2);
  transform: scaleY(0.2);
}

.man-last {
  border-bottom: 0px;
}

/* 2. 统一图标区域的行高，与容器高度一致 */
.icon-left {
  width: 14%;
  line-height: 0.85rem; /* 与man的height一致，让图标垂直居中 */
  display: flex;
  justify-content: center;
  align-items: center; /* 额外确保图标在自身区域内居中 */
}

.icon-right {
  border: 0;
  height: 0.77rem;
  flex: 1; /* 替换原width:86%，自动填充中间空间 */
  color: #fff;
}

.icon-right .form-control {
  width: 100%;
  /*height: 100%;*/
  height: 0.77rem;
  /*line-height: 100%;*/
  /*background: #292929;*/
  vertical-align: middle;
  font-size: 0.28rem;
  display: block;
  text-indent: 0.1rem;
  outline: none;
  border: 0;
}

/* 假设 style 标签带 scoped（Vue 单文件组件），若不带可去掉 ::v-deep */
.icon-right .ip-input {
  color: gray; /* 原内联样式迁移至此 */
  /* 可补充其他基础样式 */
  /* 例如：字体大小、边框等 */
  /* font-size: 14px;
  padding: 6px 12px; */
}

/* 禁用状态的样式（可选，增强交互体验） */
.icon-right .ip-input:disabled {
  /* 禁用时可加深灰色或调整背景，区分状态 */
  /* color: #ccc;
  background-color: #f5f5f5; */
  cursor: not-allowed;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.btn_div_d {
  margin-top: 0.4rem;
  /*background: #fff;*/
  color: #fff;
  border: none;
  width: 100%;
  line-height: 0.82rem;
  font-size: 0.36rem;
  border-radius: 0 0 5px 5px;
}

.btn {
  text-align: center;
  line-height: 0.82rem;
  width: 90%;
  height: 0.82rem;
  margin: 0 auto;
  border: 0;
  border-radius: 0.08rem;
  display: block;
  font-size: 0.32rem;
  letter-spacing: 2px;
}
.dot-ani {
  display: none;
  height: 12px;
  line-height: 12px;
  overflow: hidden;
  font-weight: bold;
}
.dot-ani::after {
  display: inline-table;
  white-space: pre;
  content: "\A.\A..\A...";
  animation: spin 2s steps(4) infinite;
}
@keyframes spin {
  to {
    -webkit-transform: translateY(-48px);
    transform: translateY(-48px);
  }
}
.showLoading {
  display: inline-block;
}

.btn_div_d .dis_btn {
  color: #999;
  /*background: #7d606e;*/
  background: #666666;

  /*background: rgb(8,20,45);*/
  letter-spacing: 2px;
}

.btn_div_d .click_btn {
  color: #f5f9fc;
  /*background: #7d2029;*/
  /*background: #08142D;*/
  /*background: #A57518;*/
  background: #ee3f44;
  /*background: #1F1F1F;*/
}

/* 调整：当前版本与登录按钮左对齐（宽度90%+居中margin，文字左显示） */
.deal_div {
  margin: 0.3rem auto 0;
  width: 90%;
  text-align: left;
  font-size: 0.24rem;
  color: #8e8e8e;
  cursor: pointer;
}

/* 3. 让“记住密码”容器的行高与输入行一致，内容垂直居中 */
.reme-pass-wrap {
  margin-left: auto; /* 保持靠右对齐 */
  padding-right: 0.1rem;
  line-height: 0.85rem; /* 与man的height一致，文字垂直居中 */
  display: flex;
  align-items: center; /* 确保内部文字/图标垂直居中（若后续加图标也适用） */
}

/* 4. 清除“记住密码”文字的多余间距 */
.dsRemePass {
  margin: 0; /* 清除所有外边距，避免错位 */
  margin-left: 0.1rem; /* 和图标间增加一点空隙 */
  font-size: 0.2rem;
  color: #8e8e8e;
}

.footer_fixed .btn_block {
  font-size: 0.28rem;
  background: #fff;
  color: #ee3f44;
  float: right;
  cursor: pointer;
}

.fl a {
  color: #999;
}

.fl span {
  color: #666;
  font-size: 0.24rem;
}

.pass_w {
  width: 100%;
  height: 100%;
  position: relative;
}

.eye {
  position: absolute;
  top: 0.2rem;
  right: 0.5rem;
}
/* 密码错误弹出框 */
.pw_z {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.pw_k {
  position: absolute;
  width: 60%;
  height: 3rem;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  font-size: 0;
}

.pw_k div {
  width: 100%;
  height: 1.2rem;
  text-align: center;
  font-size: 0.28rem;
  letter-spacing: 1px;
  padding-top: 0.8rem;
}
.pw_k .p1 {
  width: 100%;
}
.enterImfor {
  width: 100%;
  height: 1rem;
  border: 0 none;
  outline: none;
  border-top: 1px solid #ddd;
  background-color: rgb(224, 242, 245);
  font-size: 0.32rem;
  letter-spacing: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/yj/login.vue